import React, { Component } from 'react';
import RothButton from '../components/RothButton.js';
import RothTextInput from '../components/RothTextInput.js';
import RothSelect from '../components/RothSelect.js';
import RothRadioButton from '../components/RothRadioButton.js';
import ReactModal from 'react-modal';

import img_floor_concrete_systemPlate from '../img/floor_concrete_systemPlate.png';
import img_floor_concrete_steelWire from '../img/floor_concrete_steelWire.png';
import img_floor_concrete_clampTrack from '../img/floor_concrete_clampTrack.png';
import img_floor_concrete_clips from '../img/floor_concrete_clips.png';
import img_floor_concrete_knobPanel from '../img/floor_concrete_knobPanel.png';
import img_floor_wooden_silencio from '../img/floor_wooden_silencio.png';
import img_floor_wooden_panel from '../img/floor_wooden_panel.png';
import img_floor_wooden_selfSupport from '../img/floor_wooden_selfSupport.png';
import img_floor_wooden_plywood from '../img/floor_wooden_plywood.png';
import img_floor_wooden_joists from '../img/floor_wooden_joists.png';
import img_floor_floating_universal from '../img/floor_floating_universal.png';
import img_floor_floating_compact from '../img/floor_floating_compact.png';
import img_floor_floating_climaComfort from '../img/floor_floating_climaComfort.png';

export default class RoomPage extends Component {
  constructor() {
    super();
    this.state = {
      showModal: false
    };

    this.handleOpenModal = this.handleOpenModal.bind(this);
    this.handleModalYes = this.handleModalYes.bind(this);
  }
  handleOpenModal() {
    this.setState({ showModal: true });
  }
  handleModalYes() {
    this.setState({ showModal: false });
  }
  style = {};

  images = {
    concrete: {
      systemPlate: img_floor_concrete_systemPlate,
      steelWire: img_floor_concrete_steelWire,
      clampTrack: img_floor_concrete_clampTrack,
      clips: img_floor_concrete_clips,
      knobPanel: img_floor_concrete_knobPanel
    },
    wooden: {
      silencio: img_floor_wooden_silencio,
      panel: img_floor_wooden_panel,
      selfSupport: img_floor_wooden_selfSupport,
      plywood: img_floor_wooden_plywood,
      joists: img_floor_wooden_joists
    },
    floating: {
      universal: img_floor_floating_universal,
      compact: img_floor_floating_compact,
      climaComfort: img_floor_floating_climaComfort,
      climaComfort16: img_floor_floating_climaComfort // Assuming same image for climaComfort16
    }
  };
  addRoom = () => {
    var indexOfNewRoom = this.props.addRoom(this.props.subPage);
    this.props.changePage('room', indexOfNewRoom);
  };
  handleChangeParam = () => (param, value) => {
    var response = this.props.changeRoomParam(this.props.subPage, param, value);
    if (response === 'areaChanged') {
      this.handleOpenModal();
    }
  };
  systems = () => {
    var ret = [];
    var floorStructures = this.props.options.system[this.props.room.floorType === '' ? 'default' : this.props.room.floorType];
    for (var i = 0; i < floorStructures.length; i++) {
      if (floorStructures[i] in this.props.structures && this.props.structures[floorStructures[i]] === true) {
        ret.push(floorStructures[i]);
      }
    }
    return ret;
  };
  prev = () => {
    var systems = this.systems();
    var sel = systems.indexOf(this.props.room.system);
    var newSystem = systems[(sel - 1 + systems.length) % systems.length];
    this.props.changeRoomParam(this.props.subPage, 'system', newSystem);
  };
  next = () => {
    var systems = this.systems();
    var sel = systems.indexOf(this.props.room.system);
    var newSystem = systems[(sel + 1) % systems.length];
    this.props.changeRoomParam(this.props.subPage, 'system', newSystem);
  };
  render() {
    return (
      <div className="content">
        <RothButton type="back" fn={this.props.changePage} param={this.props.backPage} value={this.props.backSubPage}>
          {'← ' + this.props.text('other', 'back')}
        </RothButton>
        <div className="inner">
          <div>
            <h1>{this.props.text('room', 'h1')}</h1>
            <div style={{ padding: '20px 40px 0px 40px' }}>
              <RothTextInput param="name" value={this.props.room.name} fn={this.handleChangeParam()}>
                {this.props.text('room', 'i1')}
              </RothTextInput>
              <RothTextInput
                type="decimal"
                param="area"
                value={this.props.room.areaString}
                placeholder={this.props.text('room', 'placeholder2')}
                fn={this.handleChangeParam()}
              >
                {this.props.text('room', 'i2')}
              </RothTextInput>
              <RothSelect
                param="floorType"
                value={this.props.room.floorType}
                fn={this.handleChangeParam()}
                options={this.props.options.floorType.reduce((ret, key) => {
                  ret[key] = this.props.text('room', 'floorType_' + key);
                  return ret;
                }, {})}
              >
                {this.props.text('room', 'i3')}
              </RothSelect>
              <RothSelect
                param="system"
                value={this.props.room.system}
                fn={this.handleChangeParam()}
                options={this.systems().reduce((ret, key) => {
                  ret[key] = this.props.text('room', 'system_' + this.props.room.floorType + '_' + key);
                  return ret;
                }, {})}
                mobileHideLabel={true}
              >
                <span>&nbsp;</span>
              </RothSelect>
            </div>
            <div style={{ padding: '40px 0px 20px 0px', position: 'relative' }}>
              <table style={{ textAlign: 'center', paddingTop: '50px' }}>
                <tbody>
                  <tr>
                    <td>
                      <RothButton type="awesome" style={{ textAlign: 'center', padding: '20px', margin: 'auto' }} fn={this.prev}>
                        chevron-left
                      </RothButton>
                    </td>
                    <td>
                      <img
                        style={{ width: '60%' }}
                        src={
                          this.props.room.floorType in this.images && this.props.room.system in this.images[this.props.room.floorType]
                            ? this.images[this.props.room.floorType][this.props.room.system]
                            : ''
                        }
                        alt=""
                      />
                    </td>
                    <td>
                      <RothButton type="awesome" style={{ textAlign: 'center', padding: '20px', margin: 'auto' }} fn={this.next}>
                        chevron-right
                      </RothButton>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div
                style={{
                  position: 'absolute',
                  top: '0px',
                  right: '20px',
                  width: '50%',
                  display: this.props.room.system === 'clips' ? 'block' : 'none'
                }}
              >
                <RothRadioButton
                  param="clips"
                  value={this.props.room.clips}
                  fn={this.handleChangeParam()}
                  options={this.props.options.clips.reduce((ret, key) => {
                    ret[key] = this.props.text('room', 'clips_' + key);
                    return ret;
                  }, {})}
                />
              </div>
              <div
                style={{
                  position: 'absolute',
                  top: '0px',
                  right: '20px',
                  width: '50%',
                  display: this.props.room.system === 'knobPanel' ? 'block' : 'none'
                }}
              >
                <RothRadioButton
                  param="knobPanel"
                  value={this.props.room.knobPanel}
                  fn={this.handleChangeParam()}
                  options={this.props.options.knobPanel.reduce((ret, key) => {
                    ret[key] = this.props.text('room', 'knobPanel_' + key);
                    return ret;
                  }, {})}
                />
              </div>
              <div
                style={{
                  position: 'absolute',
                  top: '0px',
                  right: '20px',
                  width: '50%',
                  display: this.props.room.system === 'plywood' ? 'block' : 'none'
                }}
              >
                <RothRadioButton
                  param="plywood"
                  value={this.props.room.plywood}
                  fn={this.handleChangeParam()}
                  options={this.props.options.plywood.reduce((ret, key) => {
                    // Hide 0,3 mm panel for Norway
                    if (this.props.departmentID === 103 && key === 'panel03') return ret;

                    ret[key] = this.props.text('room', 'plywood_' + key);
                    return ret;
                  }, {})}
                />
              </div>
              <div
                style={{
                  position: 'absolute',
                  top: '0px',
                  right: '20px',
                  width: '50%',
                  display: this.props.room.system === 'joists' ? 'block' : 'none'
                }}
              >
                <RothRadioButton
                  param="joists"
                  value={this.props.room.joists}
                  fn={this.handleChangeParam()}
                  options={this.props.options.joists.reduce((ret, key) => {
                    ret[key] = this.props.text('room', 'joists_' + key);
                    return ret;
                  }, {})}
                />
              </div>
            </div>
          </div>
          <div style={{ padding: '0px 40px 0px 40px' }}>
            <RothSelect
              param="pipeDimension"
              value={this.props.room.pipeDimension}
              fn={this.handleChangeParam()}
              options={this.props.options.allowedPipes[this.props.room.floorType][this.props.room.system].reduce((ret, key) => {
                // Country exception for sweden
                if (this.props.departmentID === 101 && this.props.room.floorType === 'wooden') {
                  ret[key] = this.props.text('room', 'pipeDimension_alu_laser_' + key);
                } else {
                  ret[key] = this.props.text('room', 'pipeDimension_' + key);
                }
                return ret;
              }, {})}
            >
              {this.props.text('room', 'i4')}
            </RothSelect>
          </div>
        </div>
        <div style={{ textAlign: 'center' }}>
          <RothButton disabled={this.props.room.area === 0} type="half" fn={this.props.changePage} param={'rooms'}>
            {this.props.text('room', 'done')}
          </RothButton>
          <RothButton style={this.props.oneRoomOnly ? { display: 'none' } : {}} disabled={this.props.room.area === 0} type="half" fn={this.addRoom}>
            {this.props.text('room', 'addRoom')}
          </RothButton>
        </div>
        <ReactModal
          isOpen={this.state.showModal}
          contentLabel=""
          style={{
            content: {
              position: 'absolute',
              top: '30%',
              width: 'calc(100% - 80px)',
              marginLeft: 'auto',
              marginRight: 'auto',
              height: '300px',
              border: '0px solid white',
              backgroundColor: this.props.constants.colorRed,
              borderRadius: '22px',
              padding: '40px 10px',
              maxWidth: '500px'
            }
          }}
        >
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>
            <div style={{ textAlign: 'center', color: 'white', fontSize: '30px', whiteSpace: 'pre-wrap' }}>
              {this.props
                .text('room', 'maxRoomSize')
                .replace('#area', this.props.maxMiniShuntRoomSizes[this.props.room.pipeDimension][this.props.room.system])
                .split('\n')
                .map((item, i) => (
                  <span key={i}>
                    {item}
                    <br />
                  </span>
                ))}
            </div>
            <div style={{ textAlign: 'center' }}>
              <RothButton type="halfWhite" fn={this.handleModalYes}>
                OK
              </RothButton>
            </div>
          </div>
        </ReactModal>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/views/RoomPage.js
 **/